module.exports = __webpack_public_path__ + "static/media/10.af89b8cf.png";